module.exports = {
      id: "subscribe-vikatan-usage",
      viewBox: "0 0 365.232 27",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#subscribe-vikatan",
      toString: function () {
        return this.url;
      }
    }